(function () {
  'use strict';

  function setExpanded(product, expanded) {
    var toggle = product.querySelector('[data-acc-ro-setup-toggle]');
    var panel = product.querySelector('[data-acc-ro-setup-panel]');
    var label = product.querySelector('[data-acc-ro-setup-label]');
    var iconShow = product.querySelector('[data-acc-ro-setup-icon-show]');
    var iconHide = product.querySelector('[data-acc-ro-setup-icon-hide]');
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.hidden = !expanded;
    product.classList.toggle('is-setup-open', expanded);

    if (label) {
      var showLabel = toggle.getAttribute('data-label-show') || '';
      var hideLabel = toggle.getAttribute('data-label-hide') || showLabel;
      label.textContent = expanded ? hideLabel : showLabel;
    }

    if (iconShow) iconShow.hidden = expanded;
    if (iconHide) iconHide.hidden = !expanded;

    var videos = panel.querySelectorAll('video');
    for (var i = 0; i < videos.length; i += 1) {
      if (expanded) {
        videos[i].play().catch(function () {});
      } else {
        videos[i].pause();
      }
    }
  }

  function initProduct(product) {
    var toggle = product.querySelector('[data-acc-ro-setup-toggle]');
    if (!toggle || toggle.dataset.accRoSetupBound === 'true') return;
    toggle.dataset.accRoSetupBound = 'true';

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      setExpanded(product, !isOpen);
    });

    setExpanded(product, false);
  }

  function initAll(scope) {
    var root = scope || document;
    var products = root.querySelectorAll
      ? root.querySelectorAll('.ACC_RO_Homepage_19_03_product[data-acc-ro-setup]')
      : [];
    for (var i = 0; i < products.length; i += 1) {
      initProduct(products[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
